const keyFor = userId => `ices:exchanges:last-session:${userId}`;

export function preferredSession(sessions, userId, previous = '', now = new Date()) {
  if (sessions.some(session => session.id === previous)) return previous;
  if (userId) {
    try {
      const saved = window.localStorage.getItem(keyFor(userId));
      if (sessions.some(session => session.id === saved)) return saved;
    } catch { /* Browser storage may be unavailable; use the default session. */ }
  }
  const spring = now.getMonth() < 8;
  return (sessions.find(session => session.academicYear === now.getFullYear() - Number(spring)
    && session.semester === (spring ? 'spring' : 'autumn')) || sessions[0])?.id || '';
}

export function rememberSession(userId, sessionId) {
  if (!userId || !sessionId) return;
  try { window.localStorage.setItem(keyFor(userId), sessionId); }
  catch { /* Remembering a preference must not block access to the students. */ }
}
